import React from 'react';

const SurveyFormIcon = () => {
    return (
        <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" width="40" height="40" rx="8" fill="#F2F6F9" />
            <path d="M25.5 10V12H28.507C29.055 12 29.5 12.445 29.5 12.993V29.007C29.4997 29.2703 29.395 29.5227 29.2089 29.7089C29.0227 29.895 28.7703 29.9997 28.507 30H12.493C12.2297 29.9997 11.9773 29.895 11.7911 29.7089C11.605 29.5227 11.5003 29.2703 11.5 29.007V12.993C11.5 12.445 11.945 12 12.493 12H15.5V10H25.5ZM15.5 14H13.5V28H27.5V14H25.5V16H15.5V14ZM17.5 24V26H15.5V24H17.5ZM17.5 21V23H15.5V21H17.5ZM17.5 18V20H15.5V18H17.5ZM23.5 12H17.5V14H23.5V12Z" fill="url(#paint0_linear_4213_31682)" />
            <defs>
                <linearGradient id="paint0_linear_4213_31682" x1="10.2362" y1="10" x2="30.1409" y2="10.592" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F2547D" />
                    <stop offset="1" stopColor="#FF7959" />
                </linearGradient>
            </defs>
        </svg>
    )
}

export default SurveyFormIcon;